import { notification } from 'antd'
import { useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType, UpdateTruckData } from '@types'

import { TrucksApi } from './api'

const useUpdateTruck = () => {
  const { t } = useTranslation()
  const tPreffix = 'suppliers_router.suppliers_dashboard.use_update_truck.'

  const queryClient = useQueryClient()

  const onUpdateSuccess = () => {
    queryClient.invalidateQueries(QUERY_KEYS.TRUCKS)
  }

  const updateTruck = async (truckId: number, updatedData: UpdateTruckData) => {
    try {
      await TrucksApi.updateTruck(truckId, updatedData)
      onUpdateSuccess()
      notification.success({
        message: 'Se realizo la modificacion correctamente',
      })
    } catch (error) {
      const axiosError = error as AxiosErrorType

      if (axiosError && axiosError.data && axiosError.data.error) {
        const errorResponse = axiosError.data.error
        const { type, message } = errorResponse

        if (type === 'SOME_ERROR_TYPE') {
          const hint =
            message.length > 62
              ? `${t(`${tPreffix}no_active_route_hint`)} ${message.substring(62)}`
              : `${t(`${tPreffix}no_active_route_at_all_hint`)}`

          notification.error({
            message: `${t(`${tPreffix}no_active_route`)} ${hint}`,
          })
        } else {
          notification.error({
            message: 'No se realizo la modificacion',
          })
        }
      } else {
        console.error('Error:', axiosError)
      }
    }
  }

  return {
    updateTruck,
  }
}

export { useUpdateTruck }
